import script from "./InitiatorActionLicenseConf.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitiatorActionLicenseConf.vue?vue&type=script&setup=true&lang=ts"

import "./InitiatorActionLicenseConf.vue?vue&type=style&index=0&id=5eb3fb3a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb3fb3a"]])

export default __exports__